export default __webpack_public_path__ + "assets/8e092f80444679d18086c2754aea4356.jpeg";